import React from 'react';
import { Box, Stack, Typography, LinearProgress } from '@mui/material';

const defaultSteps = ['User Authentication', 'Select Assistant', 'Initiate Call', 'Call Submitted'];

const StepProgressBar = ({ activeStep = 0, totalSteps, customSteps }) => {
	const steps = customSteps || defaultSteps;
	const stepsCount = totalSteps || steps.length;
	const progress = ((activeStep + 1) / (stepsCount - 1)) * 100;

	return (
		<Box sx={{ width: '100%', mb: 3 }}>
			<Typography sx={{ fontWeight: 600, fontSize: '12px', color: '#444242', textAlign: 'center', mb: 2 }}>
				Step {activeStep + 1} of {stepsCount - 1}
			</Typography>

			<LinearProgress
				variant="determinate"
				value={progress}
				sx={(theme) => ({
					height: { xs: 10, md: 12},
					borderRadius: 12,
					backgroundColor: theme.palette.primary.lightest_shade,
					'& .MuiLinearProgress-bar': {
						backgroundColor: theme.palette.primary.primary_shade,
						borderRadius: 4,
					},
				})}
			/>
		</Box>
	);
};

export default StepProgressBar;
